import { success, error, random } from '@/helpers/utils';
import router from '@/router/router';

export const Wizard = {
    state: {},
    mutations: {},
    getters: {
        hasWizardFinished(state, getters) {
            return getters.getProp('tecpage.user.settings.misc.wizard_finish') !== undefined;
        },
        isWizardActive(state, getters, rootState) {
            if (rootState.route.name === 'wizard') {
                return true;
            }
            return false;
        }
    },
    actions: {
        async finishWizard(context, wizardType) {
            try {
                let d = new Date();
                await context.dispatch('setProp', {
                    source: 'tecpage.user.settings.misc.wizard_finish',
                    value:
                        d.getFullYear() +
                        '-' +
                        ('0' + (d.getMonth() + 1)).slice(-2) +
                        '-' +
                        ('0' + d.getDate()).slice(-2) +
                        ' ' +
                        ('0' + d.getHours()).slice(-2) +
                        ':' +
                        ('0' + d.getMinutes()).slice(-2) +
                        ':' +
                        ('0' + d.getSeconds()).slice(-2)
                });
                if (wizardType === 'starter') {
                    await context.dispatch('createItemsStarter');
                    if (context.getters.hasPackageBasic) {
                        await context.dispatch('createItemsBasic');
                    }
                }
                if (wizardType === 'basic') {
                    await context.dispatch('createItemsBasic');
                }
                await context.dispatch('saveAllData');
                success('Erfolgreich initiiert!');
                await new Promise((resolve) => {
                    router.push({ name: 'editor' }, () => {
                        resolve();
                    });
                });
            } catch (e) {
                error('Es ist ein Fehler aufgetreten!');
                console.error(e);
                return Promise.reject();
            }
        },
        async createItemsStarter(context) {
            await context.dispatch('createMenu', {
                type: 'header',
                layout: {
                    align: random(['right']),
                    type: random([1])
                }
            });
            await context.dispatch('createMenu', {
                type: 'footer',
                layout: {
                    type: random([1])
                }
            });
            await context.dispatch('createPage', {
                type: 'home',
                menu: 'header',
                with_modules: true
            });
            await context.dispatch('createPage', {
                type: 'imprint',
                menu: 'footer',
                with_modules: true
            });
            await context.dispatch('createPage', {
                type: 'privacy',
                menu: 'footer',
                with_modules: true
            });
        },
        async createItemsBasic(context) {
            let pages = context.getters.getProp('tecpage.user.settings.misc.basicWizardToCreate');
            if (pages !== undefined && pages !== null && Object.keys(pages).length > 0) {
                for (let pages__value of Object.values(pages)) {
                    await context.dispatch('createPage', {
                        type: pages__value,
                        menu: 'header',
                        with_modules: true
                    });
                }
            }
        },
        async downgradeToStarter(context) {
            /* delete all subpages */
            let pages = context.getters.getPages;
            if (pages === null) {
                return;
            }
            pages = Object.values(pages).filter(
                (i) => !['home', 'imprint', 'privacy'].includes(i.type)
            );
            if (pages.length === 0) {
                return;
            }
            for (let pages__value of pages) {
                await context.dispatch('removeProp', {
                    source: 'tecpage.user.pages.' + pages__value.id
                });
            }

            /* delete modules from home */
            for (let modules__value of [
                'jobswidget',
                'teamwidget',
                'referenceswidget',
                'aboutwidget',
                'contactwidget'
            ]) {
                let moduleToDelete = context.getters.getModuleByPageAndType('home', modules__value);
                if (moduleToDelete !== null) {
                    await context.dispatch('removeModule', {
                        id: moduleToDelete.id,
                        confirm: false,
                        route: false,
                        save: false
                    });
                }
            }

            /* recreate about and contact module on home */
            await context.dispatch('createModule', {
                type: 'about',
                page_id: context.getters.getPageIdFromType('home'),
                layout: {
                    align: 'center',
                    type: 1
                },
                appearance: {
                    color: 2
                },
                pos: 5 - 0.1
            });
            await context.dispatch('createModule', {
                type: 'contact',
                page_id: context.getters.getPageIdFromType('home'),
                layout: {
                    align: 'left',
                    type: 4
                },
                appearance: {
                    color: 4
                },
                pos: 7 - 0.1
            });

            await context.dispatch('reindexModulePositions');
        }
    }
};
